import AppForm from '@/components/AppForm';
import AppPageTitle from '@/components/AppPageTitle';
import PATH from '@/config/paths/PATH';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';
import { Checkbox, Col, Form, Input, Row, Space } from 'antd';
import React from 'react';

function MissionCreate() {
  const [form] = Form.useForm();
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);

  return (
    <Space direction="vertical" className="w-full">
      <AppPageTitle title="Create mission" />

      <AppForm form={form} targetPath={PATH.MISSIONS.ROOT}>
        <Row gutter={24}>
          <Col span={isMobile ? 24 : 12}>
            <Form.Item
              label="Mission Name (En)"
              name="nameEnglish"
              rules={[{ message: 'Please enter English name' }]}
            >
              <Input placeholder="Enter name english" />
            </Form.Item>
            <Form.Item
              label="Mission Name (My)"
              name="nameEnglish"
              rules={[{ message: 'Please enter English name' }]}
            >
              <Input placeholder="Enter name english" />
            </Form.Item>
            <Form.Item label="Active" name="active" valuePropName="checked">
              <Checkbox></Checkbox>
            </Form.Item>
            <Form.Item
              label="Cycle (day)"
              name="nameEnglish"
              rules={[{ message: 'Please enter English name' }]}
            >
              <Input placeholder="Enter name english" />
            </Form.Item>
          </Col>

          <Col span={isMobile ? 24 : 12}>
            <Form.Item
              label="Number mission"
              name="nameEnglish"
              rules={[{ message: 'Please enter English name' }]}
            >
              <Input placeholder="Enter name english" />
            </Form.Item>
            <Form.Item
              label="Turn of Cycle"
              name="nameEnglish"
              rules={[{ message: 'Please enter English name' }]}
            >
              <Input placeholder="Enter name english" />
            </Form.Item>
            <Form.Item
              label="Heart"
              name="nameEnglish"
              rules={[{ message: 'Please enter English name' }]}
            >
              <Input placeholder="Enter name english" />
            </Form.Item>
            <Form.Item
              label="Action"
              name="nameEnglish"
              rules={[{ message: 'Please enter English name' }]}
            >
              <Input placeholder="Enter name english" />
            </Form.Item>
          </Col>
        </Row>
      </AppForm>
    </Space>
  );
}

export default MissionCreate;
